import React from "react";

const Footer = () => (
  <div className="">
    <p className="dark:text-gray-200 text-gray-700 text-center ">
      © {new Date().getFullYear()} All rights reserved by GeekRedar.com
    </p>
  </div>
);

export default Footer;
